"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorsPalette = void 0;
var colorsPalette = {
    blue: {
        default: "hsl(209, 100%, 50%)",
        light: "hsl(209, 100%, 70%)",
        lighter: "hsl(208, 100%, 97%)",
        dark: "hsl(209, 100%, 35%)",
        darker: "hsl(209, 75%, 25%)",
        superDark: "hsl(223, 46%, 24%)",
    },
    cyan: {
        default: "hsl(180, 76%, 55%)",
        light: "hsl(181, 83%, 75%)",
        lighter: "hsl(181, 83%, 90%)",
        dark: "hsl(181, 83%, 30%)",
        darker: "hsl(181, 83%, 20%)",
    },
    black: {
        default: "hsl(0, 0%, 7%)",
        light: "hsl(220, 5%, 12%)",
        lighter: "hsl(225, 5%, 16%)",
        dark: "hsl(0, 0%, 2%)",
        darker: "hsl(0, 0%, 0%)",
    },
    gray: {
        default: "hsl(221,22%, 66%)",
        light: "hsl(221,22%, 71%)",
        lighter: "hsl(221,22%, 90%)",
        superLight: "hsl(210,50%, 98%)",
        dark: "hsl(221,22%, 40%)",
        darker: "hsl(221,22%, 20%)",
    },
    white: {
        default: "hsl(0, 0%, 100%)",
        light: "hsl(0, 0%, 100%)",
        lighter: "hsl(0, 0%, 100%)",
        dark: "hsl(0, 0%, 10%)",
        darker: "hsl(0, 0%, 15%)",
    },
    red: {
        default: "hsl(0, 100%, 45%)",
        light: "hsl(0, 100%, 77%)",
        lighter: "hsl(0, 100%, 90%)",
        dark: "hsl(358, 61%, 45%)",
        darker: "hsl(358, 61%, 30%)",
    },
    green: {
        default: "hsl(112, 80%, 41%)",
        light: "hsl(112, 80%, 75%)",
        lighter: "hsl(132, 48%, 94%)",
        dark: "hsl(153, 60%, 33%)",
        darker: "hsl(153, 60%, 13%)", // #0d3523
    },
    yellow: {
        default: "hsl(47, 100%, 64%)",
        light: "hsl(55, 100%, 67%)",
        lighter: "hsl(40, 94%, 94%)",
        dark: "hsl(42, 96%, 50%)",
        darker: "hsl(42, 96%, 20%)",
    },
    orange: {
        default: "hsl(15, 74%, 57%)",
        light: "hsl(15, 74%, 67%)",
        lighter: "hsl(39, 85%, 88%)",
        dark: "hsl(15, 74%, 43%)",
        darker: "hsl(15, 74%, 30%)",
    },
    purple: {
        default: "hsl(243, 100%, 68%)",
        light: "hsl(243, 100%, 82%)",
        lighter: "hsl(243, 100%, 93%)",
        dark: "hsl(243, 100%, 58%)",
        darker: "hsl(243, 100%,35%)",
    },
    pink: {
        default: "hsl(332, 95%, 68%)",
        light: "hsl(332, 95%, 82%)",
        lighter: "hsl(332, 95%, 96%)",
        dark: "hsl(332, 95%, 58%)",
        darker: "hsl(332, 95%, 30%)",
    },
};
exports.colorsPalette = colorsPalette;
//# sourceMappingURL=colors.js.map